import { render, staticRenderFns } from "./CreateProPasswordView.vue?vue&type=template&id=38dba99a"
import script from "./CreateProPasswordView.vue?vue&type=script&lang=js"
export * from "./CreateProPasswordView.vue?vue&type=script&lang=js"
import style0 from "./CreateProPasswordView.vue?vue&type=style&index=0&id=38dba99a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports